import { useEffect, useState, useCallback } from "../_snowpack/pkg/react.js";
import { functions } from "../firebase.js";
import { httpsCallable } from "../_snowpack/pkg/firebase/functions.js";

export default function useBoxPermissions(
  boxId,
  { onError = console.error } = {}
) {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [boxPermissions, setBoxPermissions] = useState();

  const fetchPermissions = useCallback(async () => {
    setIsLoading(true);
    try {
      const { data } = await httpsCallable(
        functions(),
        "box-permissions"
      )({
        boxId,
      });
      setBoxPermissions(data);
      setIsLoaded(true);
    } catch (err) {
      onError(err);
    } finally {
      setIsLoading(false);
    }
  }, [boxId, onError]);

  useEffect(() => {
    if (!isLoaded && !isLoading) fetchPermissions();
  }, [fetchPermissions, isLoaded, isLoading]);

  return {
    isLoading,
    boxPermissions,
    reload: useCallback(() => {
      setIsLoaded(false);
    }, []),
  };
}
